/**
 * https://github.com/digitalbazaar/forge
 */
class Encrypt {
    load() {
        import('node-forge');
    }

    /**
     * 加密序列
     * @param data 加密 JSON 序列
     * @param forge node-forge 包
     * @param isEncrypt 是否加密
     */
    normalEncrypt(data: any, forge: any, isEncrypt = true, pubKey?: string): void {
        if (!isEncrypt || !forge) { return; }

        const encryptParamsList = [
            'support_finger_type',
            'model_key',
            'has_touchid',
            'has_faceid',
            'finger_data',
            'face_data',
            'need_update_soter_key',
            'google_fingerprint_locked',
            'verify_type',
            'pay_password',
            'paypass',
            'paypass2',
            'finger_type'
        ];

        const base64 = forge.util.binary.base64;
        const iv = new forge.util.ByteBuffer(new ArrayBuffer(16));

        // AES
        const AESKey = forge.random.getBytesSync(32);
        const cipher = forge.cipher.createCipher('AES-CBC', AESKey);

        const encryptParams = [];
        for (const key in data) {
            if (data.hasOwnProperty(key) && encryptParamsList.indexOf(key) !== -1 && data[key] !== '') {
                cipher.start({ iv });
                cipher.update(forge.util.createBuffer(data[key], 'utf8'));
                cipher.finish();
                data[key] = base64.encode(forge.util.binary.hex.decode(cipher.output.toHex()));
                encryptParams.push(key);
            }
        }

        // RSA
        // tslint:disable-next-line:max-line-length
        const RSAPubKey = '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAo3ELaE2xHC1iAu7NewBOHnn/jU87kD2MMHQwKbhsf1MuO7S1KGVN/a7L0snX5FKIrnVfRhvhx+UF08OvOzibtUAbxbrNFWHZqk/2Tsdv3GbQC0gsLpHy8GcHPY6Nc7Kj0XX60p2Li10rBn67Lrm4j+m+3IQtWU+TdRvFYPz+lLlZ+Wrc0ar5a8uoBphR+YbDeGS8QtHWvGqJgBjSwceqA1Mtf+QqfVebi/gW0iLaidHHFIIZgdSRiMQFsSavQDxUCTgjlQwlfIFaB5N6/lhG6jkocCLetJymHjclqRgjaujPSa+scTcfNr75qssvX4GzdLGOkouOciZdUjOOFeZusQIDAQAB-----END PUBLIC KEY-----';
        const publicKey = forge.pki.publicKeyFromPem(pubKey ? this.formatPem(pubKey) : RSAPubKey);
        const en = publicKey.encrypt(AESKey);

        if (encryptParams.length > 0) {
            data.encrypt_key = forge.util.encode64(en);
            data.encrypt_params = JSON.stringify(encryptParams);
        }
    }

    private formatPem(key: any): string {
        const prefix = '-----BEGIN PUBLIC KEY-----';
        const postfix = '-----END PUBLIC KEY-----';
        if (key.indexOf(prefix) < 0) {
            key = prefix + key;
        }

        if (key.indexOf(postfix) < 0) {
            key = key + postfix;
        }
        return key;
    }
}

export const encrypt = new Encrypt();
